import React from "react";
import "./Join.css";

const Join = () => {
	return (
		<section className="join" id="join-us">
			<div className="join-container glass-card">
				<div className="join-content">
					<div className="join-text">
						<h2 className="stroke-text">Ready to</h2>
						<h2 className="outfit">Level Up?</h2>
						<p>Don't wait for the "perfect time". Start your transformation today with Bhaktapur's elite fitness community.</p>
					</div>
					
					<div className="join-actions">
						<div className="call-box">
							<span className="outfit">Call Us Today</span>
							<div className="phone-numbers">
								<a href="tel:+9779863032963" className="btn">+977 9863032963</a>
								<a href="tel:+9779818950290" className="btn btn-outline">+977 9818950290</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Join;
